'use strict';

module.exports = {
  processRequest: function(req) {
    req.url = req.url.replace(/[^%]+/g, function(s) {
      return encodeURI(s);
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/plugins/cleanurl.js
// module id = 73
// module chunks = 35783957827783 55213770944713 173894859265406